var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h4", [_vm._v("Sound")]),
    _vm._v(" "),
    _vm.activeSound
      ? _c("div", { staticClass: "my-3" }, [
          _c("div", { staticClass: "fields-wrapper is-divider" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-6" }, [
                _c(
                  "div",
                  { staticClass: "row form-group align-items-center" },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "col-sm-3 col-form-label",
                        attrs: { for: "animation_selector" }
                      },
                      [_vm._v("\n              Sound Selector\n            ")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-9" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.activeSound.objectDbHash,
                              expression: "activeSound.objectDbHash"
                            }
                          ],
                          staticClass: "custom-select",
                          attrs: { id: "animation_selector" },
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.activeSound,
                                  "objectDbHash",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              function($event) {
                                return _vm.changeSelectedModel($event)
                              }
                            ]
                          }
                        },
                        _vm._l(_vm.getSounds, function(soundSelector, key) {
                          return _c(
                            "option",
                            {
                              key: key,
                              staticClass: "custom-select",
                              domProps: { value: key }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(soundSelector.name) +
                                  "\n                "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row form-group align-items-center" },
                  [
                    _c("label", { staticClass: "col-sm-3 col-form-label" }, [
                      _vm._v(" Sound Type ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-9" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.activeSound.soundType,
                              expression: "activeSound.soundType"
                            }
                          ],
                          staticClass: "custom-select",
                          attrs: { placeholder: "Select Sound Type" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.activeSound,
                                "soundType",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "2D" } }, [
                            _vm._v("2D")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "3D" } }, [
                            _vm._v("3D")
                          ])
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row form-group align-items-center" },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "col-sm-3 col-form-label",
                        attrs: { for: "start_time" }
                      },
                      [_vm._v("\n              Start Time\n            ")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-9" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.activeSound.startTime,
                            expression: "activeSound.startTime"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "start_time" },
                        domProps: { value: _vm.activeSound.startTime },
                        on: {
                          change: _vm.mediaStartChanged,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.activeSound,
                              "startTime",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row form-group align-items-center" },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "col-sm-3 col-form-label",
                        attrs: { for: "end_time" }
                      },
                      [_vm._v("\n              End Time\n            ")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-9" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.activeSound.endTime,
                            expression: "activeSound.endTime"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "end_time", readonly: "" },
                        domProps: { value: _vm.activeSound.endTime },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.activeSound,
                              "endTime",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row form-group align-items-center" },
                  [
                    _c("label", { staticClass: "col-sm-3 col-form-label" }, [
                      _vm._v(" Duration ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-9" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.activeSound.mediaLength,
                            expression: "activeSound.mediaLength"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "border-danger":
                            (
                              parseFloat(_vm.activeSound.endTime) -
                              parseFloat(_vm.activeSound.startTime)
                            ).toFixed(2) <= 0
                        },
                        attrs: {
                          type: "text",
                          id: "sound_duration_e",
                          readonly: ""
                        },
                        domProps: { value: _vm.activeSound.mediaLength },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.activeSound,
                              "mediaLength",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row form-group align-items-center" },
                  [
                    _c("label", { staticClass: "col-sm-3 col-form-label" }, [
                      _vm._v(" Spatial blend")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-9" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.activeSound.spatialBlend,
                            expression: "activeSound.spatialBlend"
                          }
                        ],
                        attrs: {
                          type: "range",
                          min: "0",
                          max: "10",
                          step: "0.5"
                        },
                        domProps: { value: _vm.activeSound.spatialBlend },
                        on: {
                          __r: function($event) {
                            return _vm.$set(
                              _vm.activeSound,
                              "spatialBlend",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-2" }, [
                        _vm._v(_vm._s(_vm.activeSound.spatialBlend))
                      ])
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6" }, [
                _c(
                  "div",
                  { staticClass: "row form-group align-items-center" },
                  [
                    _c("label", { staticClass: "col-sm-3 col-form-label" }, [
                      _vm._v(" Audio Options ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-9" }, [
                      _c("div", { staticClass: "row align-items-center m-0" }, [
                        _c("div", { staticClass: "col-3" }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-3" },
                          [
                            !_vm.isAudioPlaying
                              ? [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-outline-success",
                                      attrs: { id: "select_audio_duration_s" },
                                      on: { click: _vm.playCurrentSound }
                                    },
                                    [_c("i", { staticClass: "fa fa-play" })]
                                  )
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isAudioPlaying
                              ? [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-outline-warning",
                                      attrs: {
                                        id: "select_audio_duration_pause"
                                      },
                                      on: { click: _vm.pauseSound }
                                    },
                                    [_c("i", { staticClass: "fa fa-pause" })]
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-3" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-danger",
                              attrs: { id: "select_audio_duration_stop" },
                              on: { click: _vm.stopSound }
                            },
                            [_c("i", { staticClass: "fa fa-stop" })]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-3" })
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row form-group align-items-center" },
                  [
                    _c("label", { staticClass: "col-sm-3 col-form-label" }, [
                      _vm._v(" Number of Loops ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-9" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.activeSound.loopCount,
                            expression: "activeSound.loopCount"
                          }
                        ],
                        attrs: {
                          type: "range",
                          min: "0",
                          max: "10",
                          step: "0.5"
                        },
                        domProps: { value: _vm.activeSound.loopCount },
                        on: {
                          __r: function($event) {
                            return _vm.$set(
                              _vm.activeSound,
                              "loopCount",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-2" }, [
                        _vm._v(_vm._s(_vm.activeSound.loopCount))
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row form-group align-items-center" },
                  [
                    _c("label", { staticClass: "col-sm-3 col-form-label" }, [
                      _vm._v(" Volume ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-9" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.activeSound.volume,
                            expression: "activeSound.volume"
                          }
                        ],
                        attrs: {
                          type: "range",
                          min: "0",
                          max: "10",
                          step: "0.5"
                        },
                        domProps: { value: _vm.activeSound.volume },
                        on: {
                          change: _vm.updateVolume,
                          __r: function($event) {
                            return _vm.$set(
                              _vm.activeSound,
                              "volume",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-2" }, [
                        _vm._v(_vm._s(_vm.activeSound.volume))
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row form-group align-items-center" },
                  [
                    _c("label", { staticClass: "col-sm-3 col-form-label" }, [
                      _vm._v(" Pitch ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-9" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.activeSound.pitch,
                            expression: "activeSound.pitch"
                          }
                        ],
                        attrs: {
                          type: "range",
                          min: "0",
                          max: "10",
                          step: "0.5"
                        },
                        domProps: { value: _vm.activeSound.pitch },
                        on: {
                          __r: function($event) {
                            return _vm.$set(
                              _vm.activeSound,
                              "pitch",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-2" }, [
                        _vm._v(_vm._s(_vm.pitch))
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row form-group align-items-center" },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "col-sm-3 col-form-label",
                        attrs: { for: "end_time" }
                      },
                      [_vm._v("\n              Minimum Distance\n            ")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-9" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.activeSound.minimumDistance,
                            expression: "activeSound.minimumDistance"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "end_time" },
                        domProps: { value: _vm.activeSound.minimumDistance },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.activeSound,
                              "minimumDistance",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row form-group align-items-center" },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "col-sm-3 col-form-label",
                        attrs: { for: "end_time" }
                      },
                      [_vm._v("\n              Maximum Distance\n            ")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-9" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.activeSound.maximumDistance,
                            expression: "activeSound.maximumDistance"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "end_time" },
                        domProps: { value: _vm.activeSound.maximumDistance },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.activeSound,
                              "maximumDistance",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]
                )
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-acfc1806", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-acfc1806","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/story-edit-view/inspector-components/media-sounds/maininspector.vue
// module id = null
// module chunks = 